import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {MetricOPEEnum} from "./MetricOPEEnum";
import {DataTypeGroupEnum} from "../../enums/dashboard/DataTypeUnitEnum";
import {MetricDataUnitEnum} from "../../enums/dashboard/MetricDataUnitEnum";
import {DataQuantityEnum} from "../../enums/dashboard/DataQuantityEnum";
import {VMTypeEnum} from "../../models/virtualmetric/VirtualMetric";
import {WriteOnEdgeStatusEnum} from "../../enums/dashboard/WriteOnEdgeStatusEnum";

/**
 * O Inner Class
 */
class O {
  metricInstances!: MetricInstanceDTO[]
}

class MetricInstanceDTO {

  partitionId!: number;

  partitionName!: string;

  id!: number;

  type!: string;

  name!: string;

  dataTypeGroup!: DataTypeGroupEnum;

  dataTypeGroupMax!: number | null;

  dataTypeGroupMin!: number | null;

  deviceName!: string;

  decimalDigits!: number | null;

  dataUnit!: MetricDataUnitEnum;

  DataQuantity!: DataQuantityEnum;

  lastValue?: any;

  lastValueTs?: any;

  vmType?: VMTypeEnum;

  wm2eInfo!: WM2EInfoDTO | null;

  wm2eStatus!: WM2EStatusDTO | null;

  dataTypeGroupShowAsHex: boolean = false;

}

class WM2EInfoDTO {
  originType?: string;
  origin?: WM2EOriginDTO;
}

class WM2EOriginDTO {
  id!: number;
  partitionId!: number;
  partitionName!: string;
  name!: string;
  deviceId!: number | null;
  deviceName!: string | null;
}

class WM2EStatusDTO {
  public ts!: number;
  public valueToWrite!: number | boolean | string;
  public commandStatus!: WriteOnEdgeStatusEnum;
  public koMessage?: string;
}

class I {
  metricInstanceIds!: number[];
}


export class GetMetricInstancesCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(MetricOPEEnum.GetMetricInstances);
    this.i = new I();
    this.o = new O();
  }
}
